<template>
	<div class="videolist">
		<div class="breadcrumb">问答专区 > 问答专区列表</div>
		<div class="searchBtn" style="border:none;display:flex">
	      	<el-button size='small' type="primary" @click="add" plain>添加</el-button>
	      	<el-button size='small' type="warning" @click="edit" plain>编辑</el-button>
	      	<el-button size='small' type="danger" @click="del" plain >删除</el-button>
	    </div>

	    <div class="main">
	      	<template>
	        	<el-table
	        		v-loading="loading"
	          		ref="multipleTable"
	          		:data="tableData"
	          		highlight-current-row
	          		tooltip-effect="dark"
	          		style="width: 100%"
	          		@current-change="handleCurrentChange">
		          	<el-table-column prop="questionName" label="问答名称"></el-table-column>
		          	<el-table-column prop="motionVideoUrl" label="视频">
				    	<template slot-scope="scope">
				    		<el-button type="primary" size="small" @click="watchVideo(scope.row.answerVideo)" v-if="scope.row.answerVideo">观看视频</el-button>
				    	</template>
				    </el-table-column>
				    <el-table-column prop="introPic" label="问答封面">
				    	<template slot-scope="scope">
				    		<img :src="scope.row.coverPic" style="width:80px" />
				    	</template>
				    </el-table-column>
				    <el-table-column prop="sort" label="排序"></el-table-column>
		          	<el-table-column prop="createTime" :formatter="this.global.dateFormat" label="创建时间"></el-table-column>	
	        	</el-table>
	      	</template>
      		<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination
		          	@current-change="handleCurrentChangePage"
		          	:current-page="pageNum"
		          	:page-size="limit"
		          	layout="total, prev, pager, next, jumper"
		          	:total="totalPage"
	        	></el-pagination>
      		</div>
    	</div>

    	<el-dialog title="视频" :visible.sync="dialogVisible2" width="35%" :before-close="handleClose">
	    	<div style="max-height:500px;max-width:100%; text-align:center">
	      		<video :src="videoUrl" controls="controls" loop="-1" style="max-height:500px;max-width:100%;"></video>
	      	</div>
	    </el-dialog>

    	<!-- 弹框 -->
    	<el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" status-icon label-width="200px">
        		<el-form-item label="问答名称" prop="questionName">
          			<el-input v-model="ruleForm.questionName" placeholder="请输入问答名称"  style="width: 80%;"></el-input>
        		</el-form-item>
        		<el-form-item label="视频链接" prop="answerVideo">
          			<el-input v-model="ruleForm.answerVideo" placeholder="请输入视频链接"  style="width: 80%;"></el-input>
        		</el-form-item>
	        	<el-form-item label="上传问答封面(343*193)" prop="coverPic">
		          	<el-input v-model="ruleForm.coverPic" placeholder style="width: 80%;"></el-input>
		          	<el-upload class="avatar-uploader" :action="tmpFiles" :show-file-list="false" :headers="headers" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
		            	<img v-if="ruleForm.coverPic" :src="ruleForm.coverPic" class="avatar" />
		            	<i v-else class="el-icon-plus avatar-uploader-icon"></i>
		          	</el-upload>
		        </el-form-item>
		        <el-form-item label="展示">
				    <el-radio-group v-model="ruleForm.screenDirection">
				      <el-radio :label="1">横屏</el-radio>
				      <el-radio :label="2">竖屏</el-radio>
				    </el-radio-group>
				</el-form-item>
        		<el-form-item label="排序">
          			<el-input v-model="ruleForm.sort" placeholder="请输入排序"  style="width: 80%;"></el-input>
        		</el-form-item>
      		</el-form>
      		<span slot="footer" class="dialog-footer">
        		<el-button @click="dialogVisible = false">取 消</el-button>
        		<el-button type="primary" @click="onSubmit('ruleForm')">确 定</el-button>
      		</span>
    	</el-dialog>

	</div>
</template>

<script>
export default {
  	mounted() {
		this.init();
  	},
  	data() {
    	return {
    		headers: {
        		xqiao_token: localStorage.getItem("token")
      		},
	      	tmpFiles: process.env.API_ROOT + "/tmpFiles",
		    tableData: [],
	      	pageNum: 1,
	      	limit: 10,
	      	totalPage: 10,
	      	currentRow: "",
	      	dialogVisible: false,
	      	loading:true,
	      	ruleForm: {
	      		coverPic:'',
	      		videoDuration:0,
	      		screenDirection:1
	      	},
	      	rules: {
		        questionName:[{ required: true, message: "请输入问答名称", trigger: 'blur' }],
		       	answerVideo:[{ required: true, message: '请输入视频链接', trigger: 'blur' }],
		       	coverPic: [{ required: true, message: "请上传问答封面",trigger: 'blur' }]
	      	},
	      	dialogVisible2:false,
	      	videoUrl:''
	    };
  	},
  	methods:{
  		watchVideo(url){
	    	if(url){
	    		this.dialogVisible2 = true
	    		this.videoUrl=url
	    	}
	    },
  		add(row){
  			this.$refs.multipleTable.setCurrentRow(row);
	      	if (this.$refs.ruleForm != undefined) {
	        	this.$refs.ruleForm.resetFields();
	        	this.ruleForm={
	        		coverPic:''
	        	}
	      	}
	      	this.dialogVisible = true;
	      	this.currentRow='';
  		},
	    edit(){
	    	if(this.currentRow.id){
	    		console.log(this.currentRow)
	    		this.ruleForm=this.currentRow;
	    		this.dialogVisible = true;
	    	}else {
	        	this.dialogVisible = false;
		        this.$message({
		          	message: "请选择信息",
		          	type: "warning"
		        });
		        return false;
	      	}
	    	
	    },
	    del(){
	      	if (this.currentRow.id) {
	        	this.$confirm("确定要删除吗?", "提示", {
		            confirmButtonText: "确定",
		            cancelButtonText: "取消",
		            type: "warning"
	          	})
	          	.then(() => {
	          		var data={id:this.currentRow.id};
	            	this.$post("/answer/delAnswerSection", JSON.stringify(data))
	              	.then(res => {
	                	if (res.code == 0) {
	                  		this.$message({
	                    		message: '删除成功',
	                    		type: "success"
	                  		});
	                  		this.currentRow='';
	                  		this.pageNum = 1;
	                  		this.init();
	                	} else {
	                  		this.$message({
	                    		message: res.message,
	                    		type: "warning"
	                  		});
	                  		return false;
	                	}
	              	})
	          	})
	      	} else {
		        this.$message({
		          	message: "请选择信息",
		          	type: "warning"
		        });
		        return false;
	      	}
	    },
    	init() {//初始化表格数据
      		var params = {
        		pageNum: this.pageNum,
        		limit: this.limit
      		};
      		this.$get("answer/getAnswerSection", params)
        	.then(res => {
          		if (res.code == 0) {
            		this.tableData = res.data.list;
            		this.totalPage = res.data.total;
            		this.loading=false;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
    	},
    	//选择需要修改的权限
    	handleCurrentChange(val) {
      		if (val) {
        		this.currentRow = val;
      		}
    	},
    	//当前页数
	    handleCurrentChangePage(val) {
	      	this.pageNum = val;
	      	this.init();
	    },
	    //弹框关闭按钮
    	handleClose(done) {
	      	if (this.$refs.ruleForm != undefined) {
	      		//this.$refs.ruleForm.resetFields();
	      		this.ruleForm={
	        		coverPic:''
	        	}
	      	}
	      	done();
    	},
    	onSubmit(formName) {
    		this.$refs[formName].validate((valid) => {
	          	if (valid) {	      	
	            	console.log(this.ruleForm)
	            	//return false
	            	this.$post("/answer/addAnswerSection", JSON.stringify(this.ruleForm))
	              	.then(res => {
	                	if (res.code == 0) {
	                  		this.$message({
	                    		message: this.ruleForm.id?'修改成功':'添加成功',
	                    		type: "success"
	                  		});		                  		
	                  		this.$refs.ruleForm.resetFields();
	                  		this.currentRow='';
	                  		this.pageNum = 1;
	                  		this.init();
	                  		this.dialogVisible = false;
	                	} else {
	                  		this.$message({
	                    		message: res.message,
	                    		type: "warning"
	                  		});
	                  		return false;
	                	}
	              	})
	          	}
	        });
    	},
    	beforeAvatarUpload(file) {
	      	const isLt2M = file.size / 1024 < 250;
	      	if (!isLt2M) {
	        	this.$message.error("上传封面大小不能超过 250kb!");
	      	}
	      	return isLt2M;
	    },
	    //选择图片成功
	    handleAvatarSuccess(res, file) {
	    	if(res.data.url){
	    		this.ruleForm.coverPic = res.data.url;
	    	}
	    },
  	}
}
</script>
<style scoped>
::deep
.avatar-uploader-icon {
    width: 108px;
    line-height: 108px
}
</style>


// WEBPACK FOOTER //
// src/views/qaSection/index.vue